module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [(_vm.loadingCertificate) ? _c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("Solicitar constancia de estudio")]), _vm._v(" "), _vm._m(0)]) : _c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("Solicitar constancia de estudio")]), _vm._v(" "), _c('message-system', {
    attrs: {
      "size": "small"
    }
  }), _vm._v(" "), (_vm.noDni) ? _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateDNI.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      Aún no tiene registrado su DNI\n        "), _c('div', {
    staticClass: "field proof-field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dni),
      expression: "dni"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Ingrese su DNI",
      "required": ""
    },
    domProps: {
      "value": (_vm.dni)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dni = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field proof-field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button button-certificate is-linkedin proof-button",
    attrs: {
      "disabled": _vm.loadingDNI,
      "type": "submit"
    }
  }, [(_vm.loadingDNI) ? _c('span', [_c('i', {
    staticClass: "fa fa-spin fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                  Guardando...\n                ")]) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                  Guardar\n                ")])])])]), _vm._v(" "), _c('small', {
    staticClass: "help is-danger"
  }, [_vm._v("*Está operación solo se podrá hacer una vez")])])])]) : _c('div', [(_vm.isStudent) ? _c('p', [_vm._v("\n        Si eres estudiante de algún curso, puedes solicitar tu constancia de estudio.\n      ")]) : _c('p', [_vm._v("\n        Lo sentimos, Usted no es estudiante en ningún curso en este momento.\n      ")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "button button-certificate is-linkedin proof-button",
    attrs: {
      "disabled": !_vm.isStudent
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToCertificate.apply(null, arguments)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Descargar")])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-spin fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n      Verificando estatus...\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee6bd4fc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/proof.vue
// module id = 430
// module chunks = 1